module.exports = __webpack_public_path__ + "img/driving-sales-home-for-the-holidays-img-1.9d2cb8d6.webp";